import React from 'react';
import PostPaymentOnboardingScreenEnhanced from '../../src/screens/auth/PostPaymentOnboardingScreenEnhanced';
import { useAuth } from '../../src/context/AuthContext';

export default function PostPaymentOnboardingRoute() {
  const { refreshAuth } = useAuth();
  return <PostPaymentOnboardingScreenEnhanced onContinue={refreshAuth} />;
}
